module.exports = __webpack_public_path__ + "static/media/LKR-logo.4148b1ca.png";